import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import WidgetThumb from 'src/components/Widget/WidgetThumb/WidgetThumb';
import { useClientConfig } from 'src/hooks/useClientConfig';
import { useIsBubbleWidget } from 'src/hooks/useIsBubbleWidget';
import { useIsEmbedded } from 'src/hooks/useIsEmbedded';

import logo from 'src/static/vectors/logo-block.svg';
import './NotFound.sass';

const NotFound = () => {
	const isBubbleWidget = useIsBubbleWidget();
	const isEmbedded = useIsEmbedded();
	const hideHostChrome = isBubbleWidget || isEmbedded;
	const client = useClientConfig();
	return (
		<div id="not-found" className="page">
			<header id="masthead">{hideHostChrome ? <WidgetThumb /> : <img src={client?.image?.toString() ?? logo} alt="logo" />}</header>
			<div className="error-illustration" />
			<section>
				<h1>
					<FormattedMessage id="error.title" />
				</h1>
				<p>
					<FormattedMessage id="not-found.text" />
				</p>
				<Link to="/" className="button">
					<FormattedMessage id="back-home" />
				</Link>
			</section>
		</div>
	);
};

export default NotFound;
